module.exports = __webpack_public_path__ + "img/visa.0b2ccfbc.svg";